import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  item: null,
  itemDetail:{}
}

const itemSlice = createSlice({
  name: 'item',
  initialState,
  reducers: {
    setItem(state, action) {
      state.item = action.payload
    },
    setItemDetail(state, action) {
      state.itemDetail = action.payload
    }
  },
})

export const {setItem, setItemDetail} = itemSlice.actions

export const selectItem = state => state.item // Selector for countryCode

export default itemSlice.reducer
